export default __webpack_public_path__ + "static/media/ic-document.e8b9897f.svg";